import { IPayloadAction, ScannerActions } from '../scanner/scanner.actions';
import { ResultsActions } from '../session/results.actions';

export function pollingReducer(state: boolean, action: IPayloadAction) {
  switch (action.type) {

    case ResultsActions.EXPIRE_PROCESSING_RESULTS:
      return false;

    case ScannerActions.SEND_IMAGES_BATCH:
      return true;

    default:
      return state;
  }
}
